/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExpenseCategory = {
    Transportation: 'TRANSPORTATION',
    Meal: 'MEAL',
    Accommodation: 'ACCOMMODATION',
    MileageAllowance: 'MILEAGE_ALLOWANCE',
    Phone: 'PHONE',
    Conference: 'CONFERENCE',
    Taxi: 'TAXI',
    CarRental: 'CAR_RENTAL',
    CarRentalFuel: 'CAR_RENTAL_FUEL',
    Parking: 'PARKING',
    Tolls: 'TOLLS',
    SoftwareHardware: 'SOFTWARE_HARDWARE',
    Miscellaneous: 'MISCELLANEOUS'
} as const;
export type ExpenseCategory = typeof ExpenseCategory[keyof typeof ExpenseCategory];


export function instanceOfExpenseCategory(value: any): boolean {
    for (const key in ExpenseCategory) {
        if (Object.prototype.hasOwnProperty.call(ExpenseCategory, key)) {
            // @ts-ignore
            if (ExpenseCategory[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExpenseCategoryFromJSON(json: any): ExpenseCategory {
    return ExpenseCategoryFromJSONTyped(json, false);
}

export function ExpenseCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseCategory {
    return json as ExpenseCategory;
}

export function ExpenseCategoryToJSON(value?: ExpenseCategory | null): any {
    return value as any;
}

